module.exports = __webpack_public_path__ + "img/tabar_withdraw2.de971bda.png";